/**
  Copyright (c) 2015, 2020, Oracle and/or its affiliates.
  Licensed under The Universal Permissive License (UPL), Version 1.0
  as shown at https://oss.oracle.com/licenses/upl/

*/
"use strict";

define('jet-composites/oms-virtual-keyboard/1.0.0/keyboard/keyboard-viewModel',["knockout", "ojs/ojcontext", "ojs/ojlogger", "simple-keyboard", "signals", "ojs/ojknockout", "ojs/ojlabel"], function (ko, Context, Logger, simpleKeyboard, signals) {
  var keyboard;

  function virtualKeyboardComponent(context) {
    var self = this,
        selectedInput;
    self.element = context.element; // let translationData = GLOBAL_UTILS.lang.createLocalTranslation("user-role-component"); // NOTE: Fetch translations
    // var newTranslationPaymentUserRoleCompObj = GLOBAL_CONFIG.useTranslationAPI === true ? (![undefined, null].includes(translationData) ? translationData : moduleTranslationPaymentRoleUserSet) : moduleTranslationPaymentRoleUserSet; 
    // NOTE: Fetch translations

    $.extend(self, init(context, selectedInput, keyboard));
  }

  function init(context, selectedInput, keyboard) {
    var self = {};
    $.extend(self, variables(context, selectedInput, keyboard), methods(self, selectedInput, keyboard));

    try {
      self.initializeValues(self, context, selectedInput);
    } catch (err) {// console.log("Revenue Centers: Unable to Initialize Values", err);
      // helpers.log.message({ message: { text: err.message }, metric: { name: "Revenue Centers Module", value: "0" } });
    }

    return self;
  }

  function variables(context) {
    var vars = {
      messageText: ko.observable('Hello from oms-virtual-keyboard-keyboard'),
      properties: context.properties
    };
    return vars;
  }
  /**
   * Function to create event click on keyboard symbols
   */


  function handleSymbolButton() {
    var currentLayout = keyboard.options.layoutName;
    var shiftToggle = currentLayout === "default" ? "symbols" : "default";
    keyboard.setOptions({
      layoutName: shiftToggle
    });
  }
  /**
   * Function to create event click on keyboard shift
   */


  function handleShiftButton() {
    var currentLayout = keyboard.options.layoutName;
    var shiftToggle; // let shiftToggle = currentLayout === "default" ? "shift" : "default";

    if (currentLayout === "default") {
      shiftToggle = "shift";
    } else if (currentLayout === "shift") {
      shiftToggle = "default";
    }

    keyboard.setOptions({
      layoutName: shiftToggle
    });
  }
  /**
   * Function to create the on key press event to be applied on the dom input element
   */


  function _onKeyPress(button) {
    console.log("Button pressed", button);
    /**
     * Shift functionality
     */

    if (button === "{lock}" || button === "{shift}") {
      handleShiftButton();
    }

    if (button === "{symbols}") {
      handleSymbolButton();
    }
  }
  /**
   * Function to create the event to be applied on the dom input element 
   */


  function onInputChange(event) {
    keyboard.setInput(event.target.value, event.target.id);
  }
  /**
   * Function to create the event on change from the input
   */


  function _onChange(input, selectedInput) {
    // console.log("Input changed", input);
    document.querySelector(selectedInput || ".oms-keyboard-field").value = input; // document.querySelector(selectedInput).value = input;
  }

  function resetInput() {
    document.querySelectorAll(".oms-keyboard-field").forEach(function (input) {
      input.value = "";
    });
  }
  /**
  * Function to to create event for input on blur on dom input
  */


  function onInputBlur(event) {
    selectedInput = "#".concat(event.target.id); //@TODO: how do we setup tracking of inputs?
    // let test = keyboard.getInput(event.target.id);
    // console.log(test);

    keyboard.setOptions({
      inputName: event.target.id
    });
  }
  /**
   * Function to to create event for input on focus on dom input
   */


  function onInputFocus(event) {
    selectedInput = "#".concat(event.target.id); //@TODO: how do we setup tracking of inputs?
    // let test = keyboard.getAllInputs();
    // console.log(test);

    keyboard.setOptions({
      inputName: event.target.id
    });
  }
  /**
   * Function to initialize the virtual keyboard
   */


  function initializeKeyboard() {
    if (keyboard) {
      keyboard.destroy();
    }

    keyboard = new simpleKeyboard["default"]({
      onChange: function onChange(input) {
        return _onChange(input, selectedInput);
      },
      onKeyPress: function onKeyPress(button) {
        return _onKeyPress(button);
      }
    });
    document.querySelectorAll(".oms-keyboard-field").forEach(function (input) {
      if (input.tagName === "OJ-SELECT-ONE" || input.tagName === "OJ-SELECT-MANY") {
        input.addEventListener('ojAnimateStart', test);
        var index = 0;
        document.querySelectorAll(".oj-listbox-input").forEach(function (input) {
          input.setAttribute("id", "testinput_" + index++);
          input.addEventListener("focus", onInputFocus); // Optional: Use if you want to track input changes
          // made without simple-keyboard

          input.addEventListener("input", onInputChange, true);
          input.addEventListener("blur", onInputBlur, true);
        });
      } else {
        input.addEventListener("focus", onInputFocus); // Optional: Use if you want to track input changes
        // made without simple-keyboard

        input.addEventListener("input", onInputChange); // input.addEventListener("blur", onInputBlur);
      }
    });
    return keyboard;
  }

  function methods(self, selectedInput, keyboard) {
    var methods = {
      initializeValues: function initializeValues(self, context, selectedInput) {
        var Signal = signals.Signal;
        window.localSignals = {
          virtualKeyboardOpen: new Signal(),
          virtualKeyboardClose: new Signal()
        };

        var terminalDeviceSelectionChangeListener = function terminalDeviceSelectionChangeListener() {
          //clear out input
          if (keyboard) {
            keyboard.clearInput("terminalSerialNum_paymentsTerminalRegistrationProcessStart");
          }
        };

        window.parent.terminalSignals.terminalDeviceSelectionChange.add(terminalDeviceSelectionChangeListener);
      },
      initKeyboard: function initKeyboard() {
        keyboard = initializeKeyboard();
      }
    };
    return methods;
  } //Lifecycle methods - uncomment and implement if necessary
  // virtualKeyboardComponent.prototype.activated = function (context) {
  //   getSelectData()
  // };
  //virtualKeyboardComponent.prototype.connected = function(context){
  //};
  //virtualKeyboardComponent.prototype.bindingsApplied = function(context){
  //};
  //virtualKeyboardComponent.prototype.disconnected = function(context){
  //};
  //virtualKeyboardComponent.prototype.propertyChanged = function(context){
  //};


  return virtualKeyboardComponent;
});
